import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,        // /api/payment_cancel?... (POST)
    paymentId: String,  // receipt/payment id
    cancel: Boolean     // true/false
  }

  async cancel(event) {
    event.preventDefault()
    if (!confirm("정말로 취소하시겠습니까?")) return

    try {
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

      const res = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "Accept": "application/json",
          "X-CSRF-Token": csrfToken
        },
        credentials: "same-origin"
      })

      const json = await res.json().catch(() => ({}))

      if (!res.ok || json.status !== "ok") {
        alert(json.error || "취소 실패")
        return
      }

      // ✅ 서버 반영이 끝난 뒤 프린트
      await this.printCancelReceipt()

    } catch (e) {
      console.error(e)
      alert("서버 통신 오류")
    }
  }

  async printCancelReceipt() {
    const el = document.querySelector('[data-controller~="receipt-printer"]')
    const ctrl = this.application.getControllerForElementAndIdentifier(el, "receipt-printer")

    // ✅ receipt-printer가 실제로 읽는 dataset에 값 주입
    el.dataset.paymentId = this.paymentIdValue
    el.dataset.cashOnly  = "true"
    el.dataset.cancel    = String(this.cancelValue)
    el.dataset.rePrint   = "true"

    // ✅ printReceipt가 async면 반드시 await
    const ret = ctrl.printReceipt?.()
    if (ret instanceof Promise) await ret
  }
}
